import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';

import { EventTypes, PaywallScreens } from '../types';
import { EventAdapter } from './EventAdapter';

export type PricingTableSource =
  | 'paywall'
  | 'header'
  | 'account_page__renew'
  | 'account_page__upgrade'
  | 'account_page__view_plans'
  | 'account_page_teams__renew'
  | 'account_page_teams__upgrade'
  | 'pricing_page';

type ViewPricingTableParams = {
  source: PricingTableSource;
  paywall_feature?: PaywallScreens;
  experiment_showbie_complete?: 'price' | 'no_price' | null;
};
export class ViewPricingTableEventAdapter extends EventAdapter {
  protected intercomEventKey = 'view_pricing_table';

  constructor({
    source,
    paywall_feature,
    experiment_showbie_complete,
  }: ViewPricingTableParams) {
    super();
    this.eventData = {
      source,
      paywall_feature,
      experiment_showbie_complete,
    };
  }

  protected amplitudeEventFunction = function sendEventData(
    event: ViewPricingTableParams
  ) {
    sendTeacherAmplitudeEvent(EventTypes.ViewPricingTable, event);
  };
}
